import { createContext } from 'react';
import CmsDealFinderGlobalConfigService from '../Services/CmsDealFinderGlobalConfigService';

const CmsDealFinderGlobalConfigContext = createContext<CmsDealFinderGlobalConfigService>(
  new CmsDealFinderGlobalConfigService()
);

export default CmsDealFinderGlobalConfigContext;
